// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer___cYqzL","mobile":"mobile___gA1Cn"};